var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$route.name !== "Standorte"
    ? _c(
        "div",
        [
          _c(
            "v-navigation-drawer",
            {
              staticClass: "vvd",
              attrs: { temporary: "", fixed: "", light: "" },
              model: {
                value: _vm.thisDrawer,
                callback: function ($$v) {
                  _vm.thisDrawer = $$v
                },
                expression: "thisDrawer",
              },
            },
            [
              _c("v-divider"),
              _c(
                "v-list-item",
                {
                  staticClass: "pointer sideItem",
                  attrs: { dark: "" },
                  on: { click: _vm.close },
                },
                [
                  _c("v-list-item-content", [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center",
                        on: {
                          "&click": function ($event) {
                            return _vm.close.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("v-icon", { attrs: { medium: "" } }, [
                              _vm._v("mdi-arrow-left"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "text-center flex-grow-1" }, [
                          _c("img", {
                            staticStyle: {
                              width: "80px",
                              height: "auto",
                              flex: "none",
                            },
                            attrs: {
                              src: require("../assets/placeholder6-opti.png"),
                            },
                            on: {
                              "&click": function ($event) {
                                return _vm.gotoStart.apply(null, arguments)
                              },
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sideContainer" },
                [
                  _c(
                    "v-list-item",
                    {
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.gotoStart.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-home")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Startseite")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.$store.state.enableAccount
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.goAccountOrSignin.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-account-circle")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(_vm.accountName)),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    {
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.gotoSortiment.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-food")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Sortiment")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.$store.state.enableFavs
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.goFavs.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-heart")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [_c("v-list-item-title", [_vm._v("Favoriten")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  _vm.$store.state.enableNews
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.gotoAktuelles.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-bell")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [_c("v-list-item-title", [_vm._v("Aktuelles")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    {
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.goLastOrders.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-history")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Bestellungen")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.$store.getters.inhouse &&
                  _vm.$store.state.enableKellnerruf
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.goKellnerruf.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("v-list-item-icon", [
                              _c("img", {
                                staticClass: "dotImg",
                                attrs: {
                                  src: require("../assets/icons/waiter.png"),
                                },
                              }),
                            ]),
                            _c(
                              "v-list-item-content",
                              [_c("v-list-item-title", [_vm._v("Kellnerruf")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  _c(
                    "v-list-item",
                    {
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.goAllergene.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-barley")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Allergene")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _vm.$store.getters.inhouse && _vm.takeawayEnabled
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.enableTakeawayMode.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-icon", [
                                  _vm._v("mdi-toggle-switch-off-outline"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Takeaway Modus"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  !_vm.$store.getters.inhouse && _vm.showInhouseMode
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.enableInhouseMode.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [
                                _c("v-icon", [
                                  _vm._v("mdi-toggle-switch-off-outline"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Inhouse Modus"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  [
                    _c(
                      "v-list-item",
                      {
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.install.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [_c("v-icon", [_vm._v("mdi-exit-to-app")])],
                          1
                        ),
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _vm._v("App installieren"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("v-divider"),
                  ],
                  [
                    _c(
                      "v-list-item",
                      {
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("shareApp")
                          },
                        },
                      },
                      [
                        _c(
                          "v-list-item-icon",
                          [_c("v-icon", [_vm._v("mdi-share-variant")])],
                          1
                        ),
                        _c(
                          "v-list-item-content",
                          [_c("v-list-item-title", [_vm._v("App teilen")])],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("v-divider"),
                  ],
                  _vm.enableGoodpay &&
                  (_vm.$store.getters.loggedIn ||
                    _vm.$store.getters.paymentMethods.length > 0)
                    ? [
                        _c(
                          "v-list-item",
                          {
                            nativeOn: {
                              "&click": function ($event) {
                                return _vm.goPaymentMethods.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              [_c("v-icon", [_vm._v("mdi-credit-card")])],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Zahlungsmittel"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                  _c(
                    "v-list-group",
                    {
                      attrs: {
                        value: false,
                        "prepend-icon": "mdi-information",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  { staticClass: "noSpace" },
                                  [_c("v-list-item-title", [_vm._v("Info")])],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1779711361
                      ),
                    },
                    [
                      _c(
                        "v-list-item",
                        {
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.goImpressum.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Impressum")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        {
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.goCookies.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("Cookie-Details"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        {
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.goDatenschutz.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("Datenschutz")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-list-item",
                        {
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.goAGBs.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("AGBs")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-list-item",
                    {
                      nativeOn: {
                        "&click": function ($event) {
                          return _vm.reload.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "v-list-item-icon",
                        [_c("v-icon", [_vm._v("mdi-refresh")])],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Neu laden")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "text-center pt-6 pb-3 pointer",
                  on: {
                    "&click": function ($event) {
                      return _vm.$ebus.$emit(
                        "gotoWebsite",
                        "https://qsignal.de"
                      )
                    },
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "150px" },
                    attrs: { src: require("../assets/powered_by_qsignal.svg") },
                  }),
                ]
              ),
              _c("div", { staticClass: "version pb-3" }, [
                _vm._v(_vm._s(_vm.displayAppVersion)),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }